module.exports = __webpack_public_path__ + "img/films.ab70739d.jpg";